
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE){
    if(window.flitsObjects.allCssJs.socialLoginJs){
        Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  }
  
   Flits(document).on("click", ".flits-back-btn", function (event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    Flits('body').removeClass('unloading');
    Flits(".flits-account-page-container").toggleClass("flits-active"), (location.hash = "");
    window.setTimeout((function() {
      return false;
    }), 50);
    return false;
  });
  if(Flits.request.page_type == 'product'){
    Flits.ajax({
        type: "POST",
        url: Flits.base_url + '/' + '6044819292205' + '/get_rule',
        data: {
            customer_hash: 'e145d87355c5df0ca9f10ab7f8a13b8775bb4c3433e67615936ec74ea79bd7ef',
            token: Flits.token,
            theme_id: Flits.theme.id
        }
        }).done((function(resp) {
             let allRuleData = resp.rules.all_rules_data;
            Flits(allRuleData).each(function(index, ele){
              if(ele.module_on == 'product_tag'){
                 let currentProductTags = Flits.product.tags;
                 let tagMatched = false;
                 if(currentProductTags){
                   Flits(ele.avails).each(function(j, jle){
                     if(currentProductTags.indexOf(jle) !== 1){
                        tagMatched = true;
                     }
                   });
                 }
                 if(tagMatched == true){
                   if(ele.is_fixed){
                     let earnlableCreditMoney = Flits.formatMoney(Math.abs(ele.credits), moneyFormat).replace(/((\,00)|(\.00))$/g, '');
                     let earnlableCreditText = Flits.t('Flits.locals.product_earnable_credit.product_earnable_credit_html', "Earn {{ earnlableCreditMoney }} on purchase of this product");
                     earnlableCreditText = earnlableCreditText.replace('{{ earnlableCreditMoney }}', `<span class="product__price-savings">${earnlableCreditMoney}</span>`);
                     let earnHtml = `<div class="flits-earn-credit-on-product product-block">${earnlableCreditText} <a href="/account#howToManageCredit" class="flits-earn-redirect">Read More</a> </div>`;
                     Flits(earnHtml).insertAfter('.product-single__meta .product-block--price');
                   }
                   else{
                     let earnlableCredit = (Number(Flits.product.price) / 100) * (Number(ele.credits) / 100 ) / 100;
                     let earnlableCreditMoney = Flits.formatMoney(Math.abs(earnlableCredit * 100), moneyFormat).replace(/((\,00)|(\.00))$/g, '');
                     let earnlableCreditText = Flits.t('Flits.locals.product_earnable_credit.product_earnable_credit_html', "Earn <span class='product__price-savings'> {{ earnlableCreditMoney }} <\/span> on purchase of this product");
                     earnlableCreditText = earnlableCreditText.replace('{{ earnlableCreditMoney }}', `<span class="product__price-savings">${earnlableCreditMoney}</span>`);
                     let earnHtml = `<div class="flits-earn-credit-on-product product-block">${earnlableCreditText} <a href="/account#howToManageCredit" class="flits-earn-redirect">Read More</a> </div>`;
                     Flits(earnHtml).insertAfter('.product-single__meta .product-block--price');
                   }
                 }
              }
            });
      })).fail((function(resp) {
            flitsSnackbar.show({
                text: resp.statusText,
                pos: 'bottom-center',
                showAction: false,
                customClass: 'flits-alert-danger'
            })
      })).always((function() {}));
  }
   
}(Flits));
